module.exports = __webpack_public_path__ + "img/question-list-one-bg.647eceb2.png";